import { Component } from '@angular/core';
import { PopUpComponent } from '../pop-up/pop-up.component';

@Component({
  selector: 'app-introduction-pop-up',
  templateUrl: './introduction-pop-up.component.html',
  styleUrls: ['./introduction-pop-up.component.scss'],
})
export class IntroductionPopUpComponent extends PopUpComponent {}
